import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import "./variables.css"
import "./index.css";
import "./tailwindstyles.css";
import App from "./App";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Suspense fallback="...loading">
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.Suspense>
);
